/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, TextField} from '@mui/material';

const PREFIX = 'Workspace';

const classes = {
  titleColumn: `${PREFIX}-titleColumn`,
  titleBox: `${PREFIX}-titleBox`,
  titleText: `${PREFIX}-titleText`,
};

const Root = styled(Box)(({theme}) => ({
  borderRadius: theme.spacing(2),
  background: '#4A4B4F',
  display: 'flex',
  flexShrink: 0,
  height: '78px',

  [`& .${classes.titleColumn}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    width: '270px',
  },

  [`& .${classes.titleBox}`]: {
    width: '100%',
    padding: theme.spacing(0, 0.5),
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background 0.15s',

    '&:hover': {
      background: '#696A6E',
    },
  },

  [`& .${classes.titleText}`]: {
    color: '#e2e3e9',
    fontSize: '20px',
    lineHeight: '24px',

    maxWidth: '250px',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

interface SettingsButtonProps {
  open: boolean;
}

const SettingsButton = styled(Button)<SettingsButtonProps>(({theme, open}) => ({
  width: '56px',
  height: '100%',
  backgroundColor: open ? theme.palette.figma_gray_middle_dark?.main : '#4A4B4F',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  outline: 'none',
  cursor: 'pointer',
  border: 'none',
  borderLeft: '1px solid #111111',
  borderRadius: theme.spacing(0, 2, 2, 0),
  transition: 'background-color 0.15s',

  '&:hover': {
    backgroundColor: theme.palette.figma_gray_middle_dark?.main,
  },
}));

const StyledTextField = styled(TextField)(({theme}) => ({
  height: '28px',
  width: '100%',
  borderRadius: '4px',
  border: '1px solid #83C0F5',

  '.MuiInputBase-input': {
    padding: theme.spacing(0, 0.5),
    color: theme.palette.figma_gray_light_4?.main,
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '24px',
  },

  fieldset: {
    border: 'none',
  },
}));

export {Root as WorkspaceRoot, classes as workspaceClasses, SettingsButton, StyledTextField};
